module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table7E"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isPunishment",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择处罚情况"
    },
    on: {
      "change": _vm.isHandle
    },
    model: {
      value: (_vm.params.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "isPunishment", $$v)
      },
      expression: "params.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [(_vm.basFirm) ? _c('el-form-item', {
    attrs: {
      "prop": "punishment",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1) : _c('el-input', {
    attrs: {
      "rows": 5,
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n              注：\n              填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-7：受处罚情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5792f8d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forEdit/table7.vue
// module id = 1739
// module chunks = 1